import { graphql } from 'react-relay';

export const checkPasswordQuery = graphql`
  query passwordCheckQuery($password: String!) {
    checkRefundUserPassword(password: $password) {
      result
      errors {
        message
        code
      }
    }
  }
`;

export const updatePasswordQuery = graphql`
  mutation passwordUpdateMutation($password: String!) {
    updateRefundUserPassword(password: $password) {
      result
      errors {
        code
        message
      }
    }
  }
`;
